export default __webpack_public_path__ + "static/media/watson-4.1e43129f.png";